/*
 * @Author: Ryan
 * @Date: 2026-01-08
 * @Description: Landing 页面通用头部组件
 */
import { Button } from 'antd';
import Image from 'next/image';
import Link from 'next/link';
import { useContext, useEffect, useState } from 'react';

import { RightContext } from '@/components/RightProvider/context';
import UserAccount from '@/components/UIComponents/UserAccount';

import styles from './index.module.scss';

interface LandingHeaderProps {
  transparent?: boolean; // 首屏透明，滚动后变白
}

const LandingHeader: React.FC<LandingHeaderProps> = ({ transparent = false }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const rightContext = useContext(RightContext);

  // 确保只在客户端检查登录状态
  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (!transparent) return;

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [transparent]);

  const bgClass = transparent && !isScrolled ? styles.transparent : styles.solid;
  const isLoggedIn = isClient && rightContext.getIsLoggedIn();

  const handleLogin = async () => {
    await rightContext.getUserLoginState({
      onReady: () => {
        // 登录成功后刷新页面或其他操作
      },
    });
  };

  return (
    <header className={`${styles.header} ${bgClass}`}>
      <div className={styles.container}>
        {/* Logo */}
        <Link href="/" className={styles.logo}>
          <Image
            src="/images/logo-with-name.png"
            alt="FalcoCut"
            width={120}
            height={32}
            priority
          />
        </Link>

        {/* 右侧操作区 */}
        <div className={styles.actions}>
          {isLoggedIn ? (
            <UserAccount />
          ) : (
            <Button type="text" className={styles.signInBtn} onClick={handleLogin}>
              Sign In
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

export default LandingHeader;
